import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as EcommerceEmailsSettingsAction from '../actions/ecommerce-emails-settings.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap} from 'rxjs/operators';
import {LoadEcommerceEmailsSettings} from "../actions";
import {EcommerceService} from "../../websites/website/ecommerce/ecommerce.service";
import {
  EmailsSettingsMapper
} from "../../websites/website/ecommerce/ecommerce-emails/emails-settings/mapper/emails-settings-mapper";

@Injectable()
export class EcommerceEmailsSettingsEffect {

  loadEcommerceEmailsSettings = createEffect(() => this._actions$.pipe(
    ofType(EcommerceEmailsSettingsAction.LOAD_ECOMMERCE_EMAILS_SETTINGS),
    mergeMap((action: LoadEcommerceEmailsSettings) => {
      const {websiteId} = action.payload;
      return this._ecommerceService.getEmailsSettings(websiteId)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success && response?.data?.dataKey) {
              const data = Array.isArray(response?.data?.dataKey) && (response?.data?.dataKey).map(EmailsSettingsMapper.map) || [];
              return new EcommerceEmailsSettingsAction.LoadEcommerceEmailsSettingsSuccess({
                data: data,
                websiteId: websiteId,
                loaded: true
              });
            }
            return new EcommerceEmailsSettingsAction.LoadEcommerceEmailsSettingsFail({websiteId});
          })
        );
    })
  ));



  constructor(
    private _actions$: Actions,
    private _ecommerceService: EcommerceService,
  ) {
  }

}
